import { render, staticRenderFns } from "./MigrationView.vue?vue&type=template&id=2ca361ba&"
import script from "./MigrationView.vue?vue&type=script&lang=js&"
export * from "./MigrationView.vue?vue&type=script&lang=js&"
import style0 from "./MigrationView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports